module.exports = __webpack_public_path__ + "img/file-shield-02.bf49bb57.svg";